/*
 * @Date: 2020-08-11 19:24:21
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-08-21 09:47:43
 * @FilePath: \pc-mall\src\utils\validate.js
 */
/**
 * Created by jiachenpan on 16/11/18.
 */

/* 是否是公司邮箱 */
export function isWscnEmail (str) {
  const reg = /^[a-z0-9](?:[-_.+]?[a-z0-9]+)*@wallstreetcn\.com$/i
  return reg.test(str.trim())
}

/* 合法uri */
export function validateURL (textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母 */
export function validateLowerCase (str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 验证key */
// export function validateKey(str) {
//     var reg = /^[a-z_\-:]+$/;
//     return reg.test(str);
// }

/* 大写字母 */
export function validateUpperCase (str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母 */
export function validatAlphabets (str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/* 手机号码 */
export function validaCellPhone (str) {
  const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
  return reg.test(str)
}

/* 符号 */
export function validaSymbol (str) {
  const reg = /^[0-9a-zA-Z]+$/
  return reg.test(str)
}

/* 身份证号码 */
export function validaIDCardNo (str) {
  const reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
  const foreignerReg = /^[A-Z]{3}[0-9]{12}$/
  return reg.test(str) || foreignerReg.test(str)
}

/* 正数 */
export function validaAmount (str) {
  const reg = /^(0|[1-9][0-9]*)(\.\d{1,2})?$/
  return reg.test(str)
}
/* 特殊字符 */
export function specialSymbols (str) {
  const reg = /[^u4e00-u9fa5w]/
  return reg.test(str)
}
